import React from 'react';

import Button from 'react-uwp/Button';
import CustomScrollbar from 'components/CustomScrollbar/CustomScrollbar';

import './ConfigsTrialCheck.styles.scss';

export default props => {
  const { userProfile, loading } = props;

  return (
    <div className="configs__trial-check__base">
      <div className="configs__title">PERÍODO DE AVALIAÇÃO INICIADO</div>
      <CustomScrollbar className="configs__scroll">
        <div className="configs__container">
          <div className="configs__container__session">
            <p className="configs__container__paragraph">Olá, {userProfile.name}</p>
            <p className="configs__container__paragraph">
              Você possui 15 dias para experimentar todas as funcionalidades do aplicativo gratuitamente
            </p>
            <div className="configs__trial-check__button">
              <Button tooltip="Entrar na NexAtlas" className="user-options__logout__button" onClick={props.onCheck} disabled={loading}>
                Iniciar
              </Button>
            </div>
          </div>
        </div>
      </CustomScrollbar>
      <div className="configs__bottom">
        Não é {userProfile.name}?{' '}
        <div className="configs__link" onClick={props.onLogout}>
          Entre com outra conta
        </div>
      </div>
    </div>
  );
};
